export default {"src":"/_next/static/media/electronicVersion.7668e28c.svg","height":152,"width":240,"blurWidth":0,"blurHeight":0};